import { Controller } from "react-hook-form";
import { Box, FormHelperText } from "@mui/material";
import { useTranslation } from "react-i18next";
import EditorComponent from "./Editor";
import { useFormContext } from "@4uhub/lib4uhub";
import { IMenuBarProps } from "./models";

interface IFormTextEditor {
  name: string;
  onlyCode?: boolean;
  readOnly?: boolean;
  menuBarProps?: IMenuBarProps;
  variables?: { name: string; code: string }[];
  maxWidth?: string;
}

const FormTextEditor: React.FC<IFormTextEditor> = ({
  name,
  onlyCode,
  readOnly = false,
  variables = [],
  maxWidth,
  menuBarProps = {
    fontSize: true,
    markFormatting: true,
    selectColor: true,
    textFormatting: true,
    linkFormatting: true,
    textAlign: true,
    addImage: true,
    addImageFromUpload: true,
    tableFormatting: false,
  },
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={""}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Box style={{ ...(maxWidth !== undefined ? { maxWidth } : {}) }}>
          <EditorComponent
            value={value}
            error={!!error}
            menuBarProps={menuBarProps}
            onlyCode={onlyCode}
            readOnly={readOnly}
            onChange={onChange}
            variables={variables}
          />
          <FormHelperText error>
            {error ? t(error?.message || "") : ""}
          </FormHelperText>
        </Box>
      )}
    />
  );
};

export default FormTextEditor;
